<template>
  <div :class="btnLink == '' ? 's-button' : 's-button-link'">
    <s-icon :iconFont="iconFont" v-if="iconFont !== ''"></s-icon>

    <img :src="require(`@/assets/images/${iconImage}`)" v-if="iconImage !== ''" />

    <span v-if="btnLink == ''" class="s-button-slot">
      <slot></slot>
    </span>

    <a v-if="btnLink != ''" :href="btnLink">
      <slot></slot>
    </a>


    <s-icon class="s-button-icon-after" :iconFont="iconFontAfter" v-if="iconFontAfter !== ''"></s-icon>

    <img :src="require(`@/assets/images/${iconImageAfter}`)" v-if="iconImageAfter !== ''" />
  </div>
</template>

<script>
import SIcon from '@/components/SIcon.vue'

export default {
  components: {
    SIcon
  },
  props: {
    btnLink: {
      type: String,
      default: ''
    },
    iconImage: {
      type: String,
      default: ''
    },
    iconFont: {
      type: String,
      default: ''
    },
    iconImageAfter: {
      type: String,
      default: ''
    },
    iconFontAfter: {
      type: String,
      default: ''
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
